import { FileSizeUnit } from '@common/enums';
import { replaceNbsps } from '@common/utils';
import { SmartSearchModel, SmartSearchModelField, SmartSearchState } from 'mbs-ui-kit';
import { Observable, of } from 'rxjs';

export function getUniqueListByProp<T>(items: T[], prop: string): T[] {
  const seen = new Map<any, T>();

  for (const item of items) {
    const value = getNestedObjectByPath(item, prop);

    if (value != null && value !== '' && !seen.has(value)) {
      seen.set(value, item);
    }
  }

  return Array.from(seen.values());
}

export function getNestedObjectByPath(obj: any, path: string): any {
  const parsedPath = path.split('/');

  parsedPath.forEach((path) => {
    obj = obj?.[path];
  });

  return obj;
}

export function getSizeFilter(tag: string, defaultTagName = 'Size less than'): SizeFilter {
  return tag === defaultTagName ? SizeFilter.Less : SizeFilter.More;
}

export function getSize(value: string): string {
  if (!value) return '';

  return value.replace(/[^0-9]/g, '');
}

export function getSizeMagnitude(value: string): FileSizeUnit {
  if (!value) return FileSizeUnit.Mb;

  const magnitude = value.replace(/[^a-z]/gi, '').toLowerCase();
  switch (magnitude) {
    case FileSizeUnit.Gb.toLowerCase():
      return FileSizeUnit.Gb;
    case FileSizeUnit.Mb.toLowerCase():
      return FileSizeUnit.Mb;
    case FileSizeUnit.Kb.toLowerCase():
      return FileSizeUnit.Kb;
    case FileSizeUnit.B.toLowerCase():
      return FileSizeUnit.B;
    default:
      return FileSizeUnit.Mb;
  }
}

export function getCustomSizeItems(state: SmartSearchState, callback: (t) => void): Observable<string[]> {
  const sizes = ['500 KB', '1 MB', '10 MB', '50 MB', '100 MB', '500 MB', '1 GB', '10 GB', '50 GB', '100 GB', '150 GB'];
  const term = state.leftCaretValue;

  callback(term);

  return of(sizes.filter((size: string) => size.toLowerCase().includes(term.toLowerCase())));
}

export const convertToPropSmartSearchModel = (data: string): SmartSearchModelField[] => new Array({ value: data });

export function getValueFromSmartSearchModel(model: SmartSearchModel, prop: string): string {
  const value: string = model[prop]?.[0].value || null;

  return typeof value === 'string' ? replaceNbsps(value) : value;
}

export enum SizeFilter {
  Less = 'less',
  More = 'more'
}

export function isSmartSearchPersist(): (curr: SmartSearchModel) => boolean {
  let last: SmartSearchModel = {};

  return function (curr: SmartSearchModel) {
    const isPersist = !curr || (Object.keys(last).length === 0 && Object.keys(curr).length === 0);

    last = curr;

    return isPersist;
  };
}
